"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMetaTags = updateMetaTags;
function updateMetaTags() {
    const hostname = window.location.hostname;
    let region = '';
    let baseURL = 'https://na.daemonxmachina.com/titanicscion/'; // Default to NA URL
    if (hostname.startsWith('eu.')) {
        region = 'Marvelous Europe';
        baseURL = 'https://eu.daemonxmachina.com/titanicscion/'; // Update to EU URL
    }
    else {
        region = 'Marvelous USA';
    }
    // Update the meta tags dynamically
    if (region) {
        document
            .querySelector('meta[property="og:title"]')
            ?.setAttribute('content', `Daemon X Machina: Titanic Scion | ${region}`);
        document
            .querySelector('meta[property="og:site_name"]')
            ?.setAttribute('content', `Daemon X Machina: Titanic Scion | ${region}`);
        document
            .querySelector('meta[name="twitter:title"]')
            ?.setAttribute('content', `Daemon X Machina Titanic Scion | ${region}`);
        document
            .querySelector('meta[property="og:url"]')
            ?.setAttribute('content', baseURL);
        document
            .querySelector('meta[name="twitter:url"]')
            ?.setAttribute('content', baseURL);
        document
            .querySelector('link[rel="canonical"]')
            ?.setAttribute('href', baseURL);
        // Update the image URL (if required based on region)
        const imageURL = `${baseURL}img/og_img.jpg`;
        document
            .querySelector('meta[property="og:image"]')
            ?.setAttribute('content', imageURL);
        document
            .querySelector('meta[name="image"]')
            ?.setAttribute('content', imageURL);
    }
}
